<script>
import {useStore} from "vuex";
import {ref} from "vue";
import {useRoute} from "vue-router";
import Swals from "@/assets/js/Swals";
import FreeWorld from "@/assets/js/FreeWorld";
import useClipboard from "vue-clipboard3";

export default {
  name: "RegisterPage",

  setup() {

    let store = useStore()
    let states = ref([])
    let cities = ref([])
    let guilds = ref([])
    let loading = ref(false)


    let data = ref({
      phone: useRoute().params.phone,
      name: '',
      prov_id: null,
      city_id: null,
      category_id: null,
      agent_code: '',
    })

    let uid = null



    function get_guilds() {
      loading.value = true
      FreeWorld.Heisenberg({action: 'guilds'}, 'info').then((res) => {

        guilds.value = res.data
        data.value.category_id = guilds.value[0].id
        get_country()

      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, get_guilds, true)
      })
    }
    get_guilds()
    function get_country() {
      loading.value = true
      FreeWorld.Heisenberg({action: 'cities'}, 'info').then((res) => {

        loading.value = false
        states.value = res.data
        data.value.prov_id = states.value[0].id
        cities.value = states.value[0].city
        data.value.city_id = cities.value[0].id

      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, get_country, true)
      })
    }

    function change_state() {

      states.value.forEach((item)=>{
        if (item.id == data.value.prov_id){
          cities.value = item.city
          data.value.city_id = item.city[0].id
        }
      })

    }

    function register() {

      if (data.value.name.trim().length == 0) {Swals.Fault('لطفا نام و نام خانوادگی خود را وارد کنید'); return false}
      if (data.value.agent_code.length === 0) data.value.agent_code = null

      loading.value = true
      FreeWorld.Heisenberg(data.value , 'register').then((res)=>{

        loading.value = false

        if (res.data.status === 'ok'){
          let id = FreeWorld.PinkMan(res.data.uid , 'en')
          localStorage.setItem('uid' , id)
          uid = res.data.uid
          run_app()

        }else if(res.data.event === 'duplicate phone'){
          Swals.Fault('پروفایل شما قبلا ثبت شده است' , 'LoginPage')
        }else if(res.data.event === 'agent not exist'){
          Swals.Fault('متاسفانه کد معرف شما اشتباه است!')
        } else{
          Swals.Fault('متاسفانه ثبت نام شما انجام نشد')
        }

      }).catch((res)=>{
        loading.value = false
        Swals.Catch(res , register)
      })

    }

    function run_app() {
      loading.value = true

          FreeWorld.Heisenberg({action: 'addresses', uid:uid}, 'info').then((res) => {

            store.commit('set_address', res.data)

              FreeWorld.Heisenberg({action: 'cards', uid:uid}, 'info').then((res) => {

                store.commit('set_Card', res.data.cards)

                FreeWorld.Heisenberg({action: 'profile', uid:uid}, 'info').then((res) => {

                  store.commit('set_profile', res.data)

                    loading.value = false
                    window.location.href = "/HomePage"

                }).catch((res) => {
                  loading.value = false
                  Swals.Catch(res, run_app, true)
                })

              }).catch((res) => {
                loading.value = false
                Swals.Catch(res, run_app, true)
              })

          }).catch((res) => {
            loading.value = false
            Swals.Catch(res, run_app, true)
          })
    }

    let showSupport = ref(true)

    function hideSupportCall() {
      showSupport.value = false;
    }

    function showSupportCall() {
      showSupport.value = true;
    }

    const {toClipboard} = useClipboard()
    async function call_support() {
      let phone_support = store.state.info.phone
      await Swals.Dialog(phone_support, null, 'کپی کردن', 'انصراف').then(async (res) => {
        if (res.isConfirmed) {
          try {
            await toClipboard(phone_support)
            Swals.Done('شماره پشتیبانی با موفقیت کپی شد');
          } catch (e) {
            Swals.Fault('متاسفانه شماره پشتیبانی کپی نشد!');
          }
        }
      });
    }

    return {

      data,
      states,
      cities,
      guilds,
      change_state,
      register,
      loading,
      call_support,
      showSupport,
      hideSupportCall,
      showSupportCall,

    }
  }
}
</script>


<template>

  <div id="main" class="">

    <img class="patch position-absolute max_width top-0" src="../assets/img/Path.png" alt="">

    <div class="d-flex justify-content-center mt-5">
      <img class="position-relative img_logo" src="../assets/img/logo.png" alt="">
    </div>

    <div class="p-body position-relative w-100 mt-1">
      <div class="rounded-4 shadow-custom py-4 w-100 p-body filter_blur">
        <p class="font-4 text-center text-white font-bold mb-3">لطفا استان و شهر مورد نظر خود را انتخاب کنید</p>

        <div class="p-2 mb-1 rounded-pill position-relative bg-white">
          <input v-model="data.name" @focusin="hideSupportCall" @focusout="showSupportCall" class="w-100 font-4 border-0 p-2 text-center" type="text" placeholder="نام و نام خانوادگی">
          <img class="position-absolute icon_phone" src="../assets/img/icon_user_bg_color.svg" alt="">
        </div>

        <div class="p-2 mb-1 rounded-pill position-relative bg-white">
          <select @change="change_state" v-model="data.prov_id" class="w-100 font-4 border-0 p-2 text-center">
            <option v-for="item in states" :key="item.id" :value="item.id">{{ item.name }}</option>
          </select>
          <img class="position-absolute icon_phone" src="../assets/img/icon_place_bg_color.svg" alt="">
        </div>

        <div class="p-2 mb-1 rounded-pill position-relative bg-white">
          <select v-model="data.city_id" class="w-100 font-4 border-0 p-2 text-center">
            <option v-for="item in cities" :key="item.id" :value="item.id">{{ item.name }}</option>
          </select>
          <img class="position-absolute icon_phone" src="../assets/img/icon_place_bg_color.svg" alt="">
        </div>

        <div class="p-2 rounded-pill position-relative bg-white mb-1">
          <select v-model="data.category_id" class="w-100 font-4 border-0 p-2 text-center">
            <option v-for="item in guilds" :key="item.id" :value="item.id">{{ item.name }}</option>
          </select>
          <img class="position-absolute icon_phone" src="../assets/img/icon_wallet_bg_color.svg" alt="">
        </div>

        <div class="p-2 mb-1 rounded-pill position-relative bg-white">
          <input v-model="data.agent_code" @focusin="hideSupportCall" @focusout="showSupportCall" onkeydown="return event.key !== ' '" class="w-100 font-4 border-0 p-2 text-center" type="text" placeholder="کد معرف (اختیاری)">
          <img class="position-absolute icon_phone" src="../assets/img/icon_user_bg_color.svg" alt="">
        </div>


        <div style="margin-top: 5vh" class="w-100 d-flex justify-content-center">
          <v-btn :loading="loading" @click="register" class="bg-color-light h-100 shadow-custom rounded-3 py-3 w-70">ثبت</v-btn>
        </div>
      </div>
    </div>

    <div v-show="showSupport" id="support_call" class="position-fixed max_width w-100 bottom-0">
      <div @click="call_support"
           style="width: 10rem" class="bg-color p-1 shadow-custom rounded-pill d-flex align-items-center mr-3 mb-3">
        <img class="icon-size-5" src="../assets/img/icon_phon_liner.svg" alt="">
        <p class="font-4 text-white mr-3">پشتیبانی</p>
      </div>
    </div>

  </div>

</template>

<style scoped>

.patch {
  width: 101%;
  height: 700px;
}

.icon_phone{
  right: 0;
  width: 3.5rem;
  height: 3.5rem;
  top: 54%;
  transform: translate(0, -52%);
}

.filter_blur {
  backdrop-filter: saturate(1) blur(15px);
  -webkit-backdrop-filter: blur(10px);
  background-color: #f0f8ff1c;
}

.img_logo {
  height: 250px;
}

</style>